import { render } from "./InstructorLogbookReport.vue?vue&type=template&id=28226e73&scoped=true"
import script from "./InstructorLogbookReport.vue?vue&type=script&lang=js"
export * from "./InstructorLogbookReport.vue?vue&type=script&lang=js"

import "./InstructorLogbookReport.vue?vue&type=style&index=0&id=28226e73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28226e73"]])

export default __exports__